import React from 'react';
import { useSelector } from 'react-redux';
import cashflowIcon from '../../../../../assets/images/deals/cashflowSimulator.svg';
import { RootState } from '../../../../../store/rootReducer';
import CashflowSimulatorModal from '../../modal/CashflowSimulator';

const CashflowSimulator: React.FC = () => {
    const deal = useSelector((state: RootState) => state.deal.deal);

    return (
        <div className="bg-[#ffff]  border border-[#27AE60]">
            <div className="flex gap-1 items-center justify-between">
                <div className="px-6 py-4">
                    <p className="font-[WorkSans] text-[#27AE60] text-xs pt-[8px]">SIMPLE YET POWERFUL</p>
                    <p className="text-[#0F2240] font-[WorkSans-Bold] font-bold text-lg uppercase">
                        Cash Flow Simulator
                    </p>
                    <p className="text-[#20222B] font-[Lato] text-sm py-3">
                        Simulate how income and private credit product can generate recurring cash flow to your
                        portfolio
                    </p>
                    <CashflowSimulatorModal deal={deal} />
                </div>

                <img src={cashflowIcon} alt="cashflow" height={'200px'} width={'150px'} />
            </div>
        </div>
    );
};

export default CashflowSimulator;
